import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  renew(event) {
    const cookiebot = window.Cookiebot;
    if (!cookiebot || typeof cookiebot.renew !== "function") return;

    event.preventDefault();
    cookiebot.renew();
  }
}
